import { useState } from 'react';

import { faWarehouse as faDuotoneWarehouse } from '@fortawesome/pro-duotone-svg-icons';
import { faImageSlash, faWarehouse } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { clsx } from 'clsx';

type CompanyLogoProps = {
    logoUrl: string;
    variant?: 'default' | 'small';
    isActive?: boolean;
};

const CompanyLogo = ({ logoUrl, variant = 'default', isActive = false }: CompanyLogoProps) => {
    const [picture, setPicture] = useState(
        logoUrl ? (
            <img
                src={logoUrl}
                alt=''
                className='w-full object-contain'
                onError={() => {
                    setPicture(
                        <div className='flex w-full items-center justify-center'>
                            <FontAwesomeIcon
                                icon={faImageSlash}
                                className='text-gray-400'
                            />
                        </div>
                    );
                }}
            />
        ) : null
    );
    return (
        <div
            className={clsx(
                'relative flex shrink-0 cursor-pointer overflow-hidden rounded-md',
                variant === 'small' ? 'size-8' : 'size-12',
                {
                    'bg-white': logoUrl,
                    'border border-solid border-gray-200': logoUrl && variant !== 'small',
                    transparent: !logoUrl && variant === 'small',
                    'bg-gray-200': !logoUrl && variant !== 'small',
                }
            )}
            data-component-name='CompanyLogo'
        >
            {picture ? (
                picture
            ) : variant === 'small' ? (
                <FontAwesomeIcon
                    icon={faWarehouse}
                    className={clsx('m-auto', isActive ? 'text-black' : 'text-white')}
                />
            ) : (
                <FontAwesomeIcon
                    icon={faDuotoneWarehouse}
                    className='m-auto text-gray-500'
                />
            )}
        </div>
    );
};

export { CompanyLogo };
